module.exports = __webpack_public_path__ + "media/b_ppair_win.7f5dee94.mp3";